module.exports = __webpack_public_path__ + "img/empresas.fae17285.gif";